import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../../-routeParams';

const title = i18n.t(($) => $.form.pageTitle.edit, { ns: 'contract' });

export const Route = createFileRoute(
  '/(main)/demand/contracts/$contractId/edit/',
)({
  head: () => getRouteHead(title, 'Bearbeite deinen Vertrag in VESTIGAS'),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const DEMAND_CONTRACT_EDIT = buildRouteExport({
  Route,
  ...routeParams,
});
